var browser = {
  ua:null,
  init:function()
  {
    this.ua = navigator.userAgent.toLowerCase();
    this.ua = {
      isLtIE8   : typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
      isLtIE9   : document.uniqueID && typeof window.matchMedia == "undefined",
      isIE      : document.uniqueID,
      isFirefox : /firefox/.test(this.ua),
      isChrome  : /chrome/.test(this.ua),
      isWebKit  : /applewebkit/.test(this.ua),
      isMobile  : /mobile/.test(this.ua),
      isIOS     : /i(phone|pod|pad)/.test(this.ua),
      isIPhone  : /iphone/.test(this.ua),
      isIPad    : /ipad/.test(this.ua),
      isAndroid : /android/.test(this.ua)
    }
  }
}

module.exports=browser



/** WEBPACK FOOTER **
 ** ./src/components/browser.js
 **/